import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-viewport-helloboard-desktop",
  "use": "foquz-icon-viewport-helloboard-desktop-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-viewport-helloboard-desktop\"><path d=\"M12 18.966V12a1 1 0 011-1h4a1 1 0 011 1v6.966M12 19h6m-17-.932V4.071a1 1 0 011-1h18a1 1 0 011 1v13.936a1 1 0 01-.997 1l-18 .061a1 1 0 01-1.003-1z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol